module.exports = __webpack_public_path__ + "img/谷物.ca43907a.jpg";